import { JwtAxios, BrandJwtAxios } from '@/packaging';

export const productApi = {
  async SearchProduct(model) {
    const res = await JwtAxios.post(`/Product/SearchProduct`, model);
    return res;
  },
  async GetLuxItemListByCategory() {
    const res = await JwtAxios.post(`/Product/GetLuxItemListByCategory`);
    return res;
  },
  async getDashBoardData() {
    const res = await JwtAxios.get(`/Product/getDashBoardData`);
    return res;
  },
  async getcharts() {
    const res = await JwtAxios.get(`/Product/getcharts`);
    return res;
  },

  async RemoveProduct(model) {
    const res = await JwtAxios.delete(`/Product/RemoveProduct`, model);
    return res;
  },
  async SearchBrandProduct(model) {
    const res = await JwtAxios.post(`/Product/LuxItemList`, model);
    return res;
  },
  async GetMemo(id) {
    const res = await JwtAxios.get(`/Product/GetMemo?id=${id}`);
    return res;
  },
  async SetMemo(model) {
    const res = await JwtAxios.patch('/Product/SetMemo', model);
    return res;
  },
  async getProductBasicInfo(id) {
    const res = await JwtAxios.get(`/Product/GetProductBasicInfo?id=${id}`);
    return res;
  },
  async updateProductBasicInfo(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductBasicInfo`, body);
    return res;
  },
  async getProductMainImages(id) {
    const res = await JwtAxios.get(`/Product/GetProductMainImages?id=${id}`);
    return res;
  },
  async updateProductMainImages(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductMainImages`, body);
    return res;
  },
  async SetProductMainImagesNukki(body) {
    const res = await JwtAxios.patch(`/Product/SetProductMainImagesNukki`, body);
    return res;
  },
  async getProductOptionGroups(id) {
    const res = await JwtAxios.get(`/Product/GetProductOptionGroups?id=${id}`);
    return res;
  },
  async convertDetailOption(id, body) {
    const res = await JwtAxios.post(`/Product/ConvertDetailOption?id=${id}`, body);
    return res;
  },
  async getPricingInfo(id) {
    const res = await JwtAxios.get(
      `/Product/GetPricingInfo?id=${id}`);
    return res;
  },
  async updateProductOption(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductOption`, body);
    return res;
  },
  async getProductDetailPage(id) {
    const res = await JwtAxios.get(`/Product/GetProductDetailPage?id=${id}`);
    return res;
  },
  async updateProductDetailPage(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductDetailPage`, body);
    return res;
  },
  async getProductShopeeAddInfo(id) {
    const res = await JwtAxios.get(`/Product/GetProductShopeeAddInfo?id=${id}`);
    return res;
  },
  async updateProductShopeeAddInfo(body) {
    const res = await JwtAxios.patch(`/Product/UpdateProductShopeeAddInfo?id=` + body.id, body.data);
    return res;
  },
  async VulkDelete(body) {
    const res = await JwtAxios.delete(`/Product/VulkDelete`, body);
    return res;
  },
  async GetUploadFailLog(body) {
    const res = await JwtAxios.post(`/Product/GetUploadFailLog`, body);
    return res;
  },
  async DownloadExcel(body) {
    const res = await JwtAxios.excelMultiPartPost('/Product/GetGoodsListDownloadExcel', body);
    return res;
  },
  async DownloadAllExcel(model) {
    const res = await JwtAxios.excelMultiPartPost(`/Product/GetTotalGoodsListDownloadExcel`, model);
    return res;
  },
  async uploadExcel(formData) {
    const res = await JwtAxios.upload('/Product/SetGoodsListUploadExcel', formData);
    return res;
  },
  async GetKeywords(params) {
    const res = await JwtAxios.get(`/Product/GetKeywords`, params);
    return res;
  },
  async RestoreOriginalMainImage(productId) {
    const res = await JwtAxios.get(`/Product/RestoreOriginalMainImage?productId=${productId}`);
    return res;
  },
  async ReprocessAIImage(productId) {
    const res = await JwtAxios.get(`/Product/ReprocessAIImage?productId=${productId}`);
    return res;
  },
  async RecalculateSalePrices(body) {
    const res = await JwtAxios.post(`/Product/RecalculateSalePrices`, body);
    return res;
  },
  async UpdateShippingAgencyFee(body) {
        const res = await JwtAxios.post(`/Product/UpdateShippingAgencyFee`, body);
        return res;
  },
};
